import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import Datetime from 'react-datetime';
import moment from 'moment';
import styled from 'styled-components/macro';
import { usePopper } from 'react-popper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';
import { portalRoot } from 'src/client/helpers/portalRoot';

type Props = {
  className?: string;
  maxTimestamp?: number;
  minTimestamp?: number;
  onSelect: (year: string, month: string) => void;
  selectedDate: string;
  title?: string;
};

export const MonthPicker = (props: Props) => {
  const { title, selectedDate, onSelect, className, minTimestamp = 0, maxTimestamp = moment().unix() } = props;

  const [show, setShow] = useState(false);
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement);

  const onChange = (input) => {
    if (typeof onSelect === 'function') {
      onSelect(input.format('YYYY'), input.format('M'));
      setShow(false);
    }
  };

  const validDates = (currentDate) =>
    currentDate.isAfter(moment.unix(minTimestamp)) && currentDate.isBefore(moment.unix(maxTimestamp));

  return (
    <div className={className}>
      {show &&
        ReactDOM.createPortal(
          <PickerDiv ref={setPopperElement} style={styles.popper} {...attributes.popper}>
            <Datetime
              timeFormat={false}
              dateFormat="YYYY-MM"
              input={false}
              open
              onChange={onChange}
              value={selectedDate}
              isValidDate={validDates}
            />
          </PickerDiv>,
          portalRoot,
        )}
      <div onClick={() => setShow(!show)}>
        <Title>
          {title}
          <StyledIcon forwardedRef={setReferenceElement} icon={faCalendarAlt} />
        </Title>
      </div>
    </div>
  );
};

const Title = styled.span`
  cursor: pointer;
`;

const StyledIcon = styled(FontAwesomeIcon)`
  margin-left: 10px;
`;

const PickerDiv = styled.div`
  .rdtPicker {
    border-radius: 5px;
  }
`;
